import React from 'react';

const TradeMessageIcon = () => (
    <span className='icon__compound trade-message'>
         <i className="fas fa-comment" aria-hidden="true" />
         <i className="fas fa-exchange-alt hollow-text icon__compound--top-layer"/>
    </span>
);

export default TradeMessageIcon;